import { withInstall } from '@jdesign-vue/utils'
import CollapseTransition from './src/collapse-transition.vue'

export const JdCollapseTransition = withInstall(CollapseTransition)
export default JdCollapseTransition
